import { DialogComponent } from '@theme/dialog';
import { CartAddEvent } from '@theme/events';

/**
 * A custom element that manages a cart drawer.
 *
 * @extends {DialogComponent}
 */
class CartDrawerComponent extends DialogComponent {
  connectedCallback() {
    super.connectedCallback();
    document.addEventListener(CartAddEvent.eventName, this.#handleCartAdd);
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    document.removeEventListener(CartAddEvent.eventName, this.#handleCartAdd);
  }

  #handleCartAdd = () => {
    if (this.hasAttribute('auto-open')) {
      this.showDialog();
    }
  };

  showDialog() {
    super.showDialog();

    const roktPlaceholder = this.querySelector('#rokt-placeholder');
    const iFrameLoaded = this.querySelector('#rokt-placeholder iframe');
    if(roktPlaceholder && !iFrameLoaded){
      if(dataLayer) window.dataLayer.push({event: 'roktAdZone'})                    
    }

    /**
     * Close cart drawer when installments CTA is clicked to avoid overlapping dialogs
     */
    customElements.whenDefined('shopify-payment-terms').then(() => {
      const installmentsContent = document.querySelector('shopify-payment-terms')?.shadowRoot;
      const cta = installmentsContent?.querySelector('#shopify-installments-cta');
      cta?.addEventListener('click', this.closeDialog, { once: true });
    });

    // Ensure backdrop click closes the drawer immediately
    const { dialog } = this.refs;
    if (dialog) {
      // Handle backdrop clicks - when clicking the backdrop, event.target is the dialog element
      const handleBackdropClick = (event) => {
        if (event.target === dialog) {
          this.closeDialog();
        }
      };
      // Add immediately without setTimeout to ensure it works right away
      dialog.addEventListener('click', handleBackdropClick);
    }
  }

  open() {
    this.showDialog();
  }

  close() {
    this.closeDialog();
  }
}

if (!customElements.get('cart-drawer-component')) {
  customElements.define('cart-drawer-component', CartDrawerComponent);
}
